import React from 'react';
import { useRouteError, isRouteErrorResponse, Link } from 'react-router-dom';

import NotFound from './NotFound';

const ErrorPage: React.FC = () => {
  const error = useRouteError();
  console.error(error);

  if (isRouteErrorResponse(error) && error.status === 404) {
    return <NotFound />;
  }

  // Fallback for other errors (generic)
  return (
    <div className="w-full bg-white relative overflow-hidden flex flex-col items-center justify-center min-h-screen px-6 text-center">
      {/* Huge background text */}
      <div 
        className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-[#F9F9F9] text-[200px] lg:text-[400px] font-title font-[400] pointer-events-none select-none z-0"
        style={{ lineHeight: 1 }}
      >
        Oops!
      </div>

      <div className="relative z-10 flex flex-col items-center gap-[32px]">
        <div className="flex flex-col items-center gap-[6px]">
          <h1 className="text-[#212121] text-[48px] lg:text-[64px] font-[500] font-title leading-tight">
            Something went wrong
          </h1>
          <p className="max-w-[600px] text-[#919191] text-[18px] lg:text-[20px] font-description font-[400] leading-[1.6]">
            {isRouteErrorResponse(error) 
              ? error.statusText || 'An unexpected error occurred' 
              : error instanceof Error 
                ? error.message 
                : 'An unexpected error occurred'}
          </p>
        </div>

        <Link 
          to="/" 
          className="w-[280px] h-[48px] px-[14px] py-[14px] bg-[#2776EA] rounded-[12px] flex items-center justify-center gap-[10px] hover:bg-[#1e5bb8] transition-colors shadow-lg"
        >
          <span className="text-white text-[16px] font-title font-[400]">
            Back to homepage
          </span>
        </Link>
      </div>
    </div>
  );
};

export default ErrorPage;
